(() => {
  if (window.__novariaPodalivConversionLoaded) return;
  window.__novariaPodalivConversionLoaded = true;

  const HANDLE = 'podaliv-confort-pro';
  const BUNDLE_SELECTOR = `novaria-bundle-selector[data-product-handle="${HANDLE}"]`;
  let bundle = null;
  let sticky = null;
  let mainPastViewport = false;
  let finalCtaVisible = false;

  const selectedTierCard = () => {
    if (!bundle) return null;
    return bundle.querySelector('[data-novaria-bundle-tier].is-selected') ||
      [...bundle.querySelectorAll('[data-novaria-bundle-tier]')].find((card) => card.querySelector('input[type="radio"]:checked')) ||
      bundle.querySelector('[data-novaria-bundle-tier]');
  };

  function enhanceProductDetails() {
    const section = document.querySelector('.novaria-product-details');
    const content = section?.querySelector('.novaria-product-details__content');
    if (!section || !content || content.closest('.nv-podaliv-details-accordion')) return;

    const details = document.createElement('details');
    details.className = 'nv-podaliv-details-accordion';
    details.dataset.nvPodalivAccordion = 'true';
    const summary = document.createElement('summary');
    summary.innerHTML = `
      <span class="nv-podaliv-details-accordion__summary-copy">
        <strong>Características, tallas y medidas</strong>
        <small>Abre para revisar el detalle completo</small>
      </span>
      <span class="nv-podaliv-details-accordion__icon" aria-hidden="true"></span>
    `;
    const body = document.createElement('div');
    body.className = 'nv-podaliv-details-accordion__body';
    content.before(details);
    body.appendChild(content);
    details.append(summary, body);
  }

  function markReviewSection() {
    let marker = document.querySelector('[id*="17876905176210c4cd"]');
    let section = marker?.matches?.('.shopify-section') ? marker : marker?.closest?.('.shopify-section');
    if (!section) {
      const widget = [...document.querySelectorAll('.jdgm-widget')].find((node) => !node.closest('product-info') && !node.closest('cart-drawer'));
      section = widget?.closest('.shopify-section') || null;
    }
    section?.classList.add('nv-podaliv-reviews');
  }

  function syncSticky() {
    if (!sticky || !bundle) return;
    const card = selectedTierCard();
    if (!card) return;
    const quantity = Number(card.dataset.tierQuantity || 0);
    const title = (card.dataset.tierTitle || '').trim() || (quantity ? `${quantity} pares` : 'Tu pack');
    const badge = (card.dataset.tierBadge || '').trim();
    const finalText = card.querySelector('[data-tier-final]')?.textContent?.trim() || '';
    const regularText = card.querySelector('[data-tier-regular]')?.textContent?.trim() || '';
    const tierNode = sticky.querySelector('[data-nv-podaliv-sticky-tier]');
    const finalNode = sticky.querySelector('[data-nv-podaliv-sticky-final]');
    const regularNode = sticky.querySelector('[data-nv-podaliv-sticky-regular]');
    if (tierNode) tierNode.textContent = badge ? `${title} · ${badge}` : title;
    if (finalNode) finalNode.textContent = finalText;
    if (regularNode) {
      regularNode.textContent = regularText;
      regularNode.hidden = !regularText || regularText === finalText;
    }
  }

  function updateStickyVisibility() {
    if (!sticky) return;
    const shouldShow = window.innerWidth < 750 && mainPastViewport && !finalCtaVisible;
    sticky.classList.toggle('is-visible', shouldShow);
    sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  }

  function scrollToBundle() {
    if (!bundle) return;
    sticky?.classList.remove('is-visible');
    bundle.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => {
      const emptySize = [...bundle.querySelectorAll('.novaria-bundle__select')].find((select) => !select.value && !select.disabled);
      const target = emptySize || bundle.querySelector('[data-bundle-add]');
      try { target?.focus({ preventScroll: true }); } catch (error) { target?.focus(); }
    }, 520);
  }

  function setupSticky() {
    if (!bundle || document.querySelector('.nv-podaliv-sticky')) return;
    const mainButton = bundle.querySelector('[data-bundle-add]');
    if (!mainButton) return;

    sticky = document.createElement('aside');
    sticky.className = 'nv-podaliv-sticky';
    sticky.setAttribute('aria-hidden', 'true');
    sticky.innerHTML = `
      <div class="nv-podaliv-sticky__meta">
        <span class="nv-podaliv-sticky__tier" data-nv-podaliv-sticky-tier>Tu pack</span>
        <div class="nv-podaliv-sticky__price-row">
          <s class="nv-podaliv-sticky__regular" data-nv-podaliv-sticky-regular hidden></s>
          <strong class="nv-podaliv-sticky__final" data-nv-podaliv-sticky-final></strong>
        </div>
      </div>
      <button type="button" class="nv-podaliv-sticky__button" data-nv-podaliv-sticky-button>Elegir mi pack</button>
    `;
    document.body.appendChild(sticky);
    sticky.querySelector('[data-nv-podaliv-sticky-button]')?.addEventListener('click', scrollToBundle);

    const mainObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      mainPastViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      updateStickyVisibility();
    }, { threshold: 0.04 });
    mainObserver.observe(mainButton);

    const finalCta = document.querySelector('.nv-final-cta');
    if (finalCta) {
      const finalObserver = new IntersectionObserver((entries) => {
        finalCtaVisible = Boolean(entries[0]?.isIntersecting);
        updateStickyVisibility();
      }, { threshold: 0.1 });
      finalObserver.observe(finalCta);
    }

    const bundleObserver = new MutationObserver(syncSticky);
    bundleObserver.observe(bundle, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
    bundle.addEventListener('change', syncSticky);
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    syncSticky();
  }

  function fixFinalCtaTarget() {
    const button = document.querySelector('.nv-final-cta__button[data-novaria-final-cta]');
    if (!button || button.dataset.nvPodalivTargetFixed === 'true') return;
    button.dataset.nvPodalivTargetFixed = 'true';
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToBundle();
    }, true);
  }

  function init() {
    bundle = document.querySelector(BUNDLE_SELECTOR);
    if (!bundle) return;
    document.documentElement.classList.add('nv-podaliv-enhanced');
    enhanceProductDetails();
    markReviewSection();
    setupSticky();
    fixFinalCtaTarget();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', () => window.setTimeout(init, 60));
})();
